import React, {useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Gallery as Glery, Item } from 'react-photoswipe-gallery';
import 'photoswipe/dist/photoswipe.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

function importImg(r) {
    return r.keys().map(r);
}

export default function Gallery() {
    const [currentPageIndex, setPageCount] = useState(0);
    const limit = 9;
    const options = {
        zoom: false,
        tapAction: 'close',
        doubleTapAction: false,
    };
    const Data = importImg(require.context('../img/gallery', false, /\.(png|jpg|jpeg)$/));
    const endOffset = currentPageIndex + limit;
    const currentItems = Data.slice(currentPageIndex, endOffset);
    const pageC = Math.ceil(Data.length / limit);

    const handlePageClick = (e) => {
        const newOffset = e.selected * limit;
        setPageCount(newOffset);
    };

    return (
        <section className="space-y-6 pb-5 md:pb-12">
            <div className="bg-gpage bg-no-repeat bg-center bg-cover h-[300px] lg:h-[600px] relative">
                <div className=" bg-black w-full h-full bg-opacity-30"></div>
                <div className="top-8 text-white w-full absolute text-3xl h-full flex items-center justify-center cursor-pointer lg:text-6xl">
                    <h2 style={{fontFamily: "Redressed"}} className="">Our Gallery</h2>
                </div>
            </div>
            <div className="cursor-pointer px-4 mx-auto max-w-screen-xl overflow-x-hidden">
                <div className="grid md:grid-cols-3 grid-cols-2 justify-items-center gap-2 cursor-pointer">
                    <Glery options={options}>
                        {currentItems.map((fname, index) => (
                            <div key={index} className="p-1 shadow-lg md:p-2">
                                <Item width="900" height="900" original={fname} alt="#">
                                    {({ ref, open }) => (
                                        <div className="sticky h-full">
                                            <img ref={ref} onClick={open} className="rounded-lg w-[395px] h-[200px] md:h-[300px]" alt="#" src={fname} />
                                            <div ref={ref} onClick={open} className="hidden absolute p-8 inset-0 z-10 bg-black lg:flex flex-col justify-center opacity-0 hover:opacity-100 ease-linear duration-500 transition-all bg-opacity-50">
                                                <div className=" bg-black/20 p-1 lg:p-4">
                                                    <div className=" flex justify-center text-lg text-white font-thin space-x-1">
                                                        <span className="">View Image</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Item>
                            </div>
                        ))}
                    </Glery>
                </div>
            </div>
            <ReactPaginate
                previousLabel={<FontAwesomeIcon icon={faAngleLeft} />}
                nextLabel={<FontAwesomeIcon icon={faAngleRight} />}
                breakLabel={<span className="mr-4 text-black">...</span>}
                pageCount={pageC}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName="pagination flex items-center justify-center mt-8 mb-4"
                pageClassName="block border-1 border-solid border-lightGray hover:bg-lightGray w-10 h-10 flex items-center justify-center rounded-md"
                pageLinkClassName="page-link"
                previousClassName="page-item text-center p-2 border-2 group shadow-lg hover:bg-main-color border-main-color w-12 rounded-lg"
                previousLinkClassName="page-link group-hover:text-white text-main-color"
                nextClassName="page-item text-center p-2 border-2 shadow-lg group hover:bg-main-color border-main-color w-12 rounded-lg"
                nextLinkClassName="page-link group-hover:text-white text-main-color"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                activeClassName="text-main-color font-bold"
                disabledClassName="text-gray-300 font-bold"
            />
        </section>
    );
}
